/*
Copyright 2022 Fondazione Bruno Kessler
Licensed under the EUPL, Version 1.1 or - as soon they will be approved by the European
Commission - subsequent versions of the EUPL (the "Licence"); You may not use this work
except in compliance with the Licence.

You may obtain a copy of the Licence at:
http://ec.europa.eu/idabc/eupl.html

Unless required by applicable law or agreed to in writing, software distributed under 
the Licence is distributed on an "AS IS" basis, WITHOUT WARRANTIES OR CONDITIONS OF 
ANY KIND, either express or implied. See the Licence for the specific language 
governing permissions and limitations under the Licence.
*/
import {ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit} from "@angular/core";
import {UserData} from "@app/models/user-data";
import {CommonState} from "@app/store/common/common.state";
import {AlertController, ModalController, ToastController} from "@ionic/angular";
import {Store} from "@ngxs/store";
import {
  CreateTCGroup,
  PersonalData,
  SaluteHelperService,
  TCParticipant,
  VideoChatService,
} from "@trec/api";
import {Subscription} from "rxjs";
@Component({
  selector: "c3-modal-detail-teleconsulto",
  templateUrl: "./modal-detail-teleconsulto.component.html",
  styleUrls: ["./modal-detail-teleconsulto.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class ModalDetailTeleconsultoComponent implements OnInit {
  loading = false;
  userData?: UserData | null;
  patientPersonalData?: PersonalData | null;
  groupId: any;
  name: any;
  id: any;
  maxParticipants;
  participants: any;
  selectedParticipants: {
    trecUserId: string;
    isPatient?: boolean;
    name: string;
    surname: string;
    email?: string;
    fiscalCode?: string;
  }[] = [];
  idtoRemove;
  isAddList: boolean = false;
  trecUserId;
  patientId;
  docList: any = [];
  private readonly subscr = new Subscription();
  constructor(
    private modalController: ModalController,
    private alertController: AlertController,
    private store: Store,
    private videoChatService: VideoChatService,
    private toastController: ToastController,
    private cd: ChangeDetectorRef,
    private saluteHelperService: SaluteHelperService
  ) { }

  ngOnInit(): void {
    this.patientId = this.store.selectSnapshot(CommonState.patientId);
    this.trecUserId = this.store.selectSnapshot(CommonState.userId);
    this.subscr.add(
      this.store.select(CommonState.loggedUserData).subscribe((userData) => {
        this.userData = userData;
        console.log(this.userData);
        this.cd.markForCheck();
      })
    );
    this.subscr.add(
      this.store.select(CommonState.patientPersonalData).subscribe((patientPersonalData) => {
        this.patientPersonalData = patientPersonalData;

        this.cd.markForCheck();
      })
    );
    /*for (let i = 0; i < this.participants.length; i++) {
      if (this.participants[i].trecUserId === this.trecUserId) {
        this.participants.splice(i, 1);
      }
    }*/

    this.checkMax();

    this.cd.markForCheck();
  }

  removePartecipant() {
    for (let i = 0; i < this.participants.length; i++) {
      if (this.participants[i].trecUserId === this.idtoRemove) {
        this.participants.splice(i, 1);
      }
    }
    this.getPartecipantList();
    this.selectedParticipants = [];
    this.checkMax();
  }

  checkMax() {
    if (this.participants.length > 6) {
      this.maxParticipants = true;
    } else if (this.participants.length + this.selectedParticipants?.length > 6) {
      this.maxParticipants = true;
    } else {
      this.maxParticipants = false;
    }
    this.cd.markForCheck();
  }

  addList() {
    this.isAddList = true;
    this.selectedParticipants = [];
    this.getPartecipantList();
  }

  async getPartecipantList() {
    this.loading = true;
    this.saluteHelperService.getListaMedici().subscribe((data) => {
      this.docList = data;
      this.loading = false;
      this.checkDocList();
    });
  }

  checkDocList() {
    for (let i = 0; i < this.participants.length; i++) {
      for (let j = 0; j < this.docList.length; j++) {
        if (this.participants[i].trecUserId === this.docList[j].id) {
          this.docList.splice(j, 1);
        }
      }
    }
    this.cd.markForCheck();
  }

  async updateParticipants(event: any, participant: any) {
    if (event.target.checked) {
      if (!participant.workEmail) {
        event.target.checked = false;
        const toast = await this.toastController.create({
          header: "Attenzione",
          message: "L'utente non ha un indirizzo email valido",
          duration: 3000,
          color: "warning",
          position: "bottom",
        });
        await toast.present();
        return;
      }

      if (this.participants.some((p) => p.trecUserId === participant.id)) {
        event.target.checked = false;
        const toast = await this.toastController.create({
          header: "Attenzione",
          message: "Hai già aggiunto: " + participant.name + " " + participant.surname,
          duration: 3000,
          color: "warning",
          position: "bottom",
        });
        await toast.present();
        return;
      }
      this.selectedParticipants.push({
        name: participant.name,
        surname: participant.surname,
        trecUserId: participant.id,
        email: participant.workEmail,
      });
    } else {
      this.removeParticipants(participant.trecUserId);
      this.selectedParticipants = this.selectedParticipants.filter(
        (p) => p.trecUserId !== participant.id
      );
    }
    this.checkDocList();
    this.checkMax();
    this.cd.markForCheck();
  }

  //Removes checkbox from array when you uncheck it
  removeParticipants(partecipant: String) {
    return this.selectedParticipants.findIndex((category) => {
      return category.trecUserId === partecipant;
    });
  }

  async addParticipants() {
    this.participants = this.participants.concat(this.selectedParticipants);
    this.selectedParticipants = [];
    this.isAddList = false;
    this.cd.markForCheck();
  }

  async presentAlert(participant: any) {
    //this.selectedPatient.push(participant.id);
    this.idtoRemove = participant.trecUserId;
    const alert = await this.alertController.create({
      header: "Sei sicuro di voler rimuovere " + participant.name + " " + participant.surname + "?",
      buttons: [
        {
          text: "Annulla",
          role: "cancel",
          handler: () => {
            alert.onDidDismiss();
          },
        },
        {
          text: "Rimuovi",
          role: "confirm",
          handler: () => {
            this.removePartecipant();
            alert.onDidDismiss();
          },
        },
      ],
    });

    await alert.present();
  }

  salva() {
    /*this.participants.push({trecUserId:this.userData?.personalData?.trecUserId!, isPatient: false, 
      name:this.userData?.personalData?.name!, surname:this.userData?.personalData?.surname!, fiscalCode:this.userData?.personalData?.fiscalCode!})
    */
    for (let i = 0; i < this.participants.length; i++) {
      this.participants[i].isPatient = false;
      delete (this.participants[i] as any).checked;
    }
    let physicians = this.participants;
    let tcParticipant: TCParticipant = {
      groupName: this.name,
      groupId: this.id,
      creatorId: this.trecUserId,
      physicians: physicians,
    };
    let createTCGroup: CreateTCGroup = {
      patientName: this.patientPersonalData?.name!,
      patientSurname: this.patientPersonalData?.surname!,
      patientId: this.patientId,
      physiciansGroups: tcParticipant,
    };
    this.videoChatService.updateTCGroup(createTCGroup).subscribe(
      (data) => {
        this.successToast();
      },
      (err) => {
        console.error(err);
        this.errorToast(err);
      }
    );
  }

  closeModal() {
    this.modalController.dismiss();
  }

  async errorToast(err: any) {
    const toast = await this.toastController.create({
      header: "Errore",
      message: err,
      duration: 3000,
      color: "danger",
      position: "bottom",
    });
    toast.present();
    this.closeModal();
  }

  async successToast() {
    const toast = await this.toastController.create({
      header: "Ok",
      message: "Rimozione avvenuta con successo",
      duration: 3000,
      color: "success",
      position: "bottom",
    });
    console.log("SUCCESSO");
    toast.present();
    this.closeModal();
  }
}
